import $ from "jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const setupImagePinning = () => {
  // Clear previous ScrollTriggers to avoid duplicates
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

  // Setup the pinning
  gsap.to(".reviews__image", {
    scrollTrigger: {
      trigger: ".reviews__image",
      start: "top top",
      end: "top top",
      endTrigger: ".reviews-pagination",
      pin: true,
      pinSpacing: false,
      // markers: true,
    },
  });

  // Refresh ScrollTrigger to make sure everything is recalculated
  ScrollTrigger.refresh();
};

// Run the function initially
setupImagePinning();

// Re-run the function on window resize
$(window).on("resize", setupImagePinning);

$(".item-body__content-more").on("click", function () {
  const $this = $(this);
  const $content = $this.siblings(".item-body__content");
  const $contentShort = $content.find(".content-short");
  const $contentFull = $content.find(".content-full");

  if ($contentFull.is(":visible")) {
    $contentFull.slideUp(300, () => {
      $contentShort
        .css({
          position: "static",
          opacity: 1,
        })
        .removeClass("hidden");
      $content.css("min-height", "");
      $this.text($this.data("more"));
    });
  } else {
    const shortContentHeight = $contentShort.outerHeight(true);
    $content.css("min-height", shortContentHeight);

    $contentShort
      .css({
        position: "absolute",
        opacity: 0,
      })
      .addClass("hidden");

    $contentFull.slideDown(300, () => {
      $this.text($this.data("less"));
    });
  }
});
